import { render, staticRenderFns } from "./two.html?vue&type=template&id=8c3f2838&external"
import script from "./two.vue?vue&type=script&lang=js"
export * from "./two.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports